
/* eslint-disable @typescript-eslint/camelcase */
import { defineComponent, onErrorCaptured } from "vue";
import Channels from "@/components/Channels.vue";
import Messages from "@/components/Messages.vue";
import MessageInput from "@/components/MessageInput.vue";
import Users from "@/components/Users.vue";
import Footer from "@/components/Footer.vue";
import Loading from "@/components/Loading.vue";
import { handleLogout } from "@/vuetils/useAuth";
export default defineComponent({
  name: "Layout",
  components: {
    Channels,
    Messages,
    MessageInput,
    Users,
    Loading,
    Footer
  },
  setup() {
    onErrorCaptured(e => {
      alert("There was an error")
      console.log(e)
      return true;
    });

    return {
      handleLogout
    };
  }
});
